import React from 'react'
import { Container } from './Styled'
import {ShowcaseCard} from '@locuta/locuta-ui'
import { AiFillRobot } from 'react-icons/ai'
import { Tag } from 'antd'
import { navigate } from '@reach/router'
import { useDispatch } from 'react-redux';
import { exploreBotAction } from '../../../business/actions/botActions';

type ItemProps = {
    name: string,
    id?: string | undefined
}

export const Item: React.FunctionComponent<ItemProps> = ({name, id}) => {
    const dispatch = useDispatch();
    const Content = () => {
        return (
            <>
                <Tag style={{position:"absolute", bottom:"20px"}}>Fr-fr</Tag>
            </>
        )
    }

    return (
        <Container>
            <ShowcaseCard
                style={{ height: '240px', width: '200px', position:'relative' }}
                onClick={() => dispatch(exploreBotAction.request(id!))}
                Icon={<AiFillRobot color="white"></AiFillRobot>}
                isColored={true}
                title={name}
                Content={<Content/>}
            />
        </Container>
    )
}

export default Item
